const REGEX_SPECIAL_CHARS = (/[-[\]{}()*+?.,\\^$|#\s]/g);

export function escapeRegexSpecialChars(value: string): string {
	return value.replace(REGEX_SPECIAL_CHARS, '\\$&');
}

const REGEX_SEARCH_CHARS = /[\^'"[\]{}()\\:/!~\-+]/g;

export function escapeRegexSearchChars(value: string | null): string | null {
	return value && value.replace(REGEX_SEARCH_CHARS, '\\$&');
}
